import type { CreateShareLinkInput, PublicLinkView, ShareLink } from "@shared/modules/x-avocats";
import { api } from "../../../core/lib/api";

const BASE = import.meta.env.VITE_API_BASE_URL || "";

export function createLink(input: CreateShareLinkInput): Promise<ShareLink & { url: string }> {
  return api(`/api/avocats/liens`, { method: "POST", body: JSON.stringify(input) });
}

export function listLinks(candidateId?: string): Promise<ShareLink[]> {
  return api<ShareLink[]>(`/api/avocats/liens${candidateId ? `?candidateId=${encodeURIComponent(candidateId)}` : ""}`);
}

export function revokeLink(id: string): Promise<void> {
  return api<void>(`/api/avocats/liens/${id}`, { method: "DELETE" });
}

// ---- Côté public (destinataire du lien) ----
export function publicView(token: string): Promise<PublicLinkView> {
  return api<PublicLinkView>(`/api/avocats/lien/${token}`);
}

export function requestCode(token: string): Promise<{ ok: boolean; minutes: number }> {
  return api(`/api/avocats/lien/${token}/code`, { method: "POST" });
}

export function verifyCode(token: string, code: string): Promise<PublicLinkView> {
  return api<PublicLinkView>(`/api/avocats/lien/${token}/verifier`, { method: "POST", body: JSON.stringify({ code }) });
}

export function publicFileUrl(token: string, documentId: string): string {
  return `${BASE}/api/avocats/lien/${token}/fichiers/${documentId}`;
}

export async function deposit(token: string, files: File[]): Promise<{ accepted: string[]; rejected: { name: string; reason: string }[] }> {
  const form = new FormData();
  for (const f of files) form.append("fichiers", f, f.name);
  const res = await fetch(`${BASE}/api/avocats/lien/${token}/depot`, { method: "POST", body: form, credentials: "include" });
  const body = (await res.json().catch(() => ({ accepted: [], rejected: [] }))) as { accepted: string[]; rejected: { name: string; reason: string }[] };
  if (!res.ok && !body.accepted?.length) throw new Error("dépôt refusé");
  return body;
}
